import { render, staticRenderFns } from "./AgGridNoEdits.vue?vue&type=template&id=2f9ca517&"
import script from "./AgGridNoEdits.vue?vue&type=script&lang=js&"
export * from "./AgGridNoEdits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports